import styled from "styled-components";

export const StyledColdStartControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 500px;
  position: relative;
`;
